/**
 * Fractional index 유틸: 정렬 순서를 문자열로 표현해 "맨 뒤 추가" / "두 항목 사이 삽입" 시 정렬값 생성.
 * lexicographic order = 표시 순서.
 */

/** 맨 앞 또는 리스트가 비었을 때 사용할 기본값 */
const DEFAULT_FIRST = 'n';

/**
 * prev 다음에 오는 sortOrder 생성 (맨 뒤 추가 시 사용).
 * @param prev 마지막 항목의 sortOrder, 없으면 null
 */
export function generateAfter(prev: string | null): string {
  if (prev == null || prev === '') return DEFAULT_FIRST;
  return prev + 'n';
}

/**
 * prev와 next 사이의 sortOrder 생성 (두 항목 사이 삽입 시 사용).
 * prev < next (lexicographic) 이어야 함.
 */
export function generateBetween(prev: string | null, next: string | null): string {
  if (prev == null || prev === '') {
    if (next == null || next === '') return DEFAULT_FIRST;
    // next 앞에 넣기: next보다 작고, 가능하면 next 앞쪽 문자 사용
    if (next.length === 1) return String.fromCharCode(next.charCodeAt(0) - 1) || 'a';
    return next.slice(0, -1) + String.fromCharCode(next.charCodeAt(next.length - 1) - 1);
  }
  if (next == null || next === '') return prev + 'n';

  let i = 0;
  while (prev[i] === next[i] && i < prev.length) i++;

  if (i === prev.length) {
    // prev가 next의 prefix → prev + '0' 으로 prev < s < next
    return prev + '0';
  }

  const prevCode = prev.charCodeAt(i);
  const nextCode = next.charCodeAt(i);
  if (nextCode - prevCode > 1) {
    const midCode = Math.floor((prevCode + nextCode) / 2);
    return prev.slice(0, i) + String.fromCharCode(midCode);
  }
  // prev[i]+1 === next[i] → prev.slice(0, i+1) + '0'
  return prev.slice(0, i + 1) + '0';
}
